const localStorageProxy = new Proxy(localStorage, {
  set(target, key, value) {
    // 设置 localStorage 的值
    target.setItem(key, value);
    // 创建并触发自定义事件
    const event = new Event("setItemEvent");
    event.key = key;
    event.newValue = value;
    window.dispatchEvent(event);
    return true;
  },
});

export default localStorageProxy;



// WEBPACK FOOTER //
// ./src/utils/listenToStorage.js